export default "__VITE_ASSET__CmPtATQa__"